module.exports = __webpack_public_path__ + "img/TV_android-series_X8500G.59b64225.png";